/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './header.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../../../../app/layout/header/header.component';
import * as i5 from '../../../../app/common/services/user/user.service';
const styles_HeaderComponent:any[] = [i0.styles];
export const RenderType_HeaderComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_HeaderComponent,data:{}});
export function View_HeaderComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),17,'nav',[['class',
      'navbar navbar-dark bg-dark']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),14,'div',[['class','container']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n    '])),(_l()(),i1.ɵeld(4,0,(null as any),(null as any),3,
      'a',[['class','navbar-brand navbar-text mr-auto']],[[1,'target',0],[8,'href',
          4]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,5).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(5,671744,(null as any),0,i2.RouterLinkWithHref,
      [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),i1.ɵpad(6,1),(_l()(),i1.ɵted(-1,(null as any),['Fulfillment Tools'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(9,0,(null as any),
          (null as any),6,'span',[['class','navbar-text']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i1.ɵeld(11,0,(null as any),(null as any),0,'i',[['aria-hidden',
          'true'],['class','fa fa-user']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵeld(13,0,(null as any),(null as any),1,'span',[['class','username']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(14,(null as any),['',''])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    const currVal_2:any = _ck(_v,6,0,'/');
    _ck(_v,5,0,currVal_2);
  },(_ck,_v) => {
    var _co:i4.HeaderComponent = _v.component;
    const currVal_0:any = i1.ɵnov(_v,5).target;
    const currVal_1:any = i1.ɵnov(_v,5).href;
    _ck(_v,4,0,currVal_0,currVal_1);
    const currVal_3:any = (_co.userFirstname || 'Guest');
    _ck(_v,14,0,currVal_3);
  });
}
export function View_HeaderComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-header',
      ([] as any[]),(null as any),(null as any),(null as any),View_HeaderComponent_0,
      RenderType_HeaderComponent)),i1.ɵdid(1,245760,(null as any),0,i4.HeaderComponent,
      [i5.UserService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const HeaderComponentNgFactory:i1.ComponentFactory<i4.HeaderComponent> = i1.ɵccf('app-header',
    i4.HeaderComponent,View_HeaderComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9hcHAvc3JjL2FwcC9sYXlvdXQvaGVhZGVyL2hlYWRlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2FwcC9zcmMvYXBwL2xheW91dC9oZWFkZXIvaGVhZGVyLmNvbXBvbmVudC50cyIsIm5nOi8vL3Zhci9hcHAvc3JjL2FwcC9sYXlvdXQvaGVhZGVyL2hlYWRlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9hcHAvc3JjL2FwcC9sYXlvdXQvaGVhZGVyL2hlYWRlci5jb21wb25lbnQudHMuSGVhZGVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPG5hdiBjbGFzcz1cIm5hdmJhciBuYXZiYXItZGFyayBiZy1kYXJrXCI+XG4gIDxkaXYgY2xhc3M9XCJjb250YWluZXJcIj5cbiAgICA8YSBbcm91dGVyTGlua109XCJbJy8nXVwiIGNsYXNzPVwibmF2YmFyLWJyYW5kIG5hdmJhci10ZXh0IG1yLWF1dG9cIj5GdWxmaWxsbWVudCBUb29sczwvYT5cbiAgICA8c3BhbiBjbGFzcz1cIm5hdmJhci10ZXh0XCI+XG4gICAgICA8aSBjbGFzcz1cImZhIGZhLXVzZXJcIiBhcmlhLWhpZGRlbj1cInRydWVcIj48L2k+XG4gICAgICA8c3BhbiBjbGFzcz1cInVzZXJuYW1lXCI+e3t1c2VyRmlyc3RuYW1lIHx8IFwiR3Vlc3RcIn19PC9zcGFuPlxuICAgIDwvc3Bhbj5cbiAgPC9kaXY+XG48L25hdj5cbiIsIjxhcHAtaGVhZGVyPjwvYXBwLWhlYWRlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFBLGdCQUF3Qyw0Q0FDdEM7TUFBQTtNQUFBLDBEQUF1QjtNQUFBLDJCQUNyQjtNQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7Y0FBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLHVDQUFBO01BQUE7TUFBQSxzQkFBRyxNQUE4RDtNQUFxQiw4Q0FDdEY7VUFBQTtVQUFBLDRDQUEwQjtVQUFBLGVBQ3hCO1VBQUE7VUFBQSw4QkFBNkM7TUFDN0M7VUFBQTtNQUF1QiwyQ0FBbUM7VUFBQSxhQUNyRCw0Q0FDSDtVQUFBLHVCQUNGO0lBTkM7SUFBSCxXQUFHLFNBQUg7OztJQUFBO0lBQUE7SUFBQSxXQUFBLG1CQUFBO0lBR3lCO0lBQUE7Ozs7b0JDTDdCO01BQUE7Z0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/layout/header/header.component.ngfactory.ts